import styled from 'styled-components'

const DaneOrganizacyjneStyle = styled.div`
  .checkboxLabel {
    height: auto;
    align-items: flex-start;
    margin: 0;
  }

  .checkboxLabel .MuiFormControlLabel-label {
    white-space: normal;
    line-height: 1.4;
    margin-top: 2px;
  }

  .checkboxLabel .MuiCheckbox-root {
    padding-top: 0;
  }

  .czasTrwania {
    width: 100%;
    display: grid;
    grid-template-rows: auto auto;
  }

  .czasTrwania .secondRow {
    grid-row: 2/3;
    display: grid;
    grid-template-columns: 192px 76px 192px auto 1fr;
    margin-top: 16px;
  }

  .czasTrwania .separator {
    font-size: 20px;
    text-align: center;
  }

  .czasTrwania .operator {
    font-size: 11px;
    text-align: center;
    margin: auto 16px;
  }

  .uproszczenia {
    width: 100%;
    display: grid;
  }

  .kontynuacja {
    width: 100%;
    display: grid;
    grid-template-rows: auto auto auto;
    grid-row-gap: 12px;
  }

  .polaczenie {
    width: 100%;
    display: grid;
    grid-template-rows: auto auto auto;
  }

  .srednioroczneZatrudnienie {
    width: 100%;
    display: grid;
    grid-template-columns: 304px;
  }

  .obowiazekBadania {
    width: 100%;
    display: grid;
  }

  .textArea {
    width: 100%;
    display: grid;
    min-height: 56px;
  }
`
export default DaneOrganizacyjneStyle
